export default __webpack_public_path__ + "static/Pala_10-e8614ed1e7d3556411bd77c086751b87.png";